// @mui
import { Box, Stack, Dialog, Tooltip, IconButton, DialogActions } from '@mui/material';
// hooks
import useToggle from 'src/hooks/useToggle';

// components
import Iconify from 'src/components/Iconify';
//localization
import { AttendanceReportResult, EmployeeDetail } from 'src/@types/attendanceReport';

import { themeMode } from 'src/utils/general';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { IContractInfo } from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';
import ElectricityPaymentDcumentPDF from './ElectricityPaymentDcumentPDF';
import { IRentPayment } from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import { IElectricityPayment } from 'src/@types/Choqorak/MainTables/ElectricityPayment/ElectricityPayment';
import ElectricityConsumptionPDF from './ElectricityConsumptionPDF';

// ----------------------------------------------------------------------

type Props = {
  Report: IElectricityPayment[];
  year?: number;
  month?: number;
};

export default function ElectricityConsumptionToolbar({ Report, year, month }: Props) {
  const { toggle: open, onClose } = useToggle();

  const print = () => {
    handlePrint();
  };

  const contentToPrint = useRef(null);
  const handlePrint = useReactToPrint({
    pageStyle: `
    @page { size: A4}; 
      `,
    content: () => contentToPrint.current,
  });

  //

  return (
    <>
      <Stack direction="row" spacing={1} sx={{ borderRadius: 1, ml: 1 }}>
        <>
          <Tooltip title="Print">
            <IconButton sx={{ color: themeMode() === 'light' ? 'black' : 'white' }} onClick={print}>
              <Iconify icon={'eva:printer-fill'} />
            </IconButton>
          </Tooltip>
        </>
      </Stack>

      <Dialog fullScreen open={open}>
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          <DialogActions
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              zIndex: 9,
              padding: '12px !important',
              boxShadow: (theme) => theme.customShadows.z8,
            }}
          >
            <Tooltip title="Print">
              <IconButton
                sx={{ color: themeMode() === 'light' ? 'black' : 'white' }}
                onClick={print}
              >
                <Iconify icon={'eva:printer-fill'} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Close">
              <IconButton color="inherit" onClick={onClose}>
                <Iconify icon={'eva:close-fill'} />
              </IconButton>
            </Tooltip>
          </DialogActions>
          <Box sx={{ flexGrow: 1, height: '100%', overflow: 'hidden' }}>
            <div className="h-full overflow-y-auto">
              <ElectricityConsumptionPDF Report={Report} year={Number(year)} month={month} />
            </div>
          </Box>
        </Box>
      </Dialog>
      <div ref={contentToPrint} className="hidden print:block">
        <ElectricityConsumptionPDF Report={Report} year={Number(year)} month={Number(month)} />
      </div>
    </>
  );
}
